// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__24-aj","regres":"regres__1T3uw","regres-body":"regres-body__3MsMV","regres-img":"regres-img__jve7x"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/User/RegistSuccess/styles/main.scss
// module id = 2321
// module chunks = 1